import { Box, Stack, Typography } from "@mui/material";
import { OtlExport } from "./OtlExport";
import { FoodExport } from "./FoodExport";

export default function Dashboard() {
  return (
    <Stack component="main" spacing={4} sx={{ py: { xs: 1, md: 3 } }}>
      <Box>
        <Typography component="h1" variant="h4" fontWeight={700} gutterBottom>
          Internal dashboard
        </Typography>
        <Typography color="text.secondary">
          Download program data. Select your filters, then choose an export.
        </Typography>
      </Box>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: {
            xs: "minmax(0, 1fr)",
            lg: "minmax(0, 1.3fr) minmax(0, 1fr)",
          },
          gap: 3,
        }}
      >
        <OtlExport />
        <FoodExport />
      </Box>
    </Stack>
  );
}
